import { mapMutations } from 'vuex';
import SongList from '@/components/MusicListItem/SongList.vue';
export default {
  name: 'MusicListItemList',

  setup(props) {
    console.log(props);
  },

  data() {
    return {};
  },

  props: ['songList', 'subscribedCount'],
  components: {
    SongList
  },
  methods: {
    playmusic(index) {
      this.updatePlayList(this.songList);
      this.updateplayListIndex(index);
    },

    ...mapMutations(['updatePlayList', 'updateplayListIndex'])
  }
};